import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { AgentActivitiesService } from './agentActivititesApi';
import { IAgentActivitiesListState } from '../../../../interfaces/agent-activitites/IAgentActivitiesList';


const initialState: IAgentActivitiesListState = {
    activityIsLoading: false,
    activitiesAreLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchActivities = createAsyncThunk<any, IPaginationPayload>(
    'agentActivities/tryToFetchActivities',
    async ({ pageNumber, pageSize, data }) => {
        const result = await AgentActivitiesService.tryToFetchActivities(pageNumber, pageSize, data);
        return result?.data;
    },
);

export const tryToFetchLogsStats = createAsyncThunk<any, any>(
    'agentActivities/tryToFetchLogsStats',
    async (data: any) => {
        const result = await AgentActivitiesService.tryToFetchLogsStats(data);
        return result?.data?.data;
    },
);

export const tryToFetchInsights = createAsyncThunk<any, any>(
    'agentActivities/tryToFetchInsights',
    async (data: any) => {
        const result = await AgentActivitiesService.tryToFetchInsights(data);
        return result?.data?.data;
    },
);

export const tryToFetchSingleActivity = createAsyncThunk<any, string>(
    'agents/tryToFetchSingleActivity',
    async (id: string) => {
        const result = await AgentActivitiesService.tryToFetchSingleActivity(id);
        return result?.data?.data;
    },
);

export const agentActivitiesSlice = createSlice({
    name: 'agentActivities',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchActivities
            .addCase(tryToFetchActivities.pending, (state) => {
                state.activitiesAreLoading = true;
            })
            .addCase(tryToFetchActivities.rejected, (state) => {
                state.activitiesAreLoading = false;
            })
            .addCase(tryToFetchActivities.fulfilled, (state, action) => {
                state.activitiesAreLoading = false;
                state.agentActivities = action.payload;
            })

            // tryToFetchLogsStats
            .addCase(tryToFetchLogsStats.pending, (state) => {
                state.activitiesAreLoading = true;
            })
            .addCase(tryToFetchLogsStats.rejected, (state) => {
                state.activitiesAreLoading = false;
            })
            .addCase(tryToFetchLogsStats.fulfilled, (state, action) => {
                state.activitiesAreLoading = false;
                state.stats = action.payload;
            })

            // tryToFetchInsights
            .addCase(tryToFetchInsights.pending, (state) => {
                state.activitiesAreLoading = true;
            })
            .addCase(tryToFetchInsights.rejected, (state) => {
                state.activitiesAreLoading = false;
            })
            .addCase(tryToFetchInsights.fulfilled, (state, action) => {
                state.activitiesAreLoading = false;
                state.insights = action.payload;
            })

            // tryToFetchSingleActivity
            .addCase(tryToFetchSingleActivity.pending, (state) => {
                state.activityIsLoading = true;
            })
            .addCase(tryToFetchSingleActivity.rejected, (state) => {
                state.activityIsLoading = false;
            })
            .addCase(tryToFetchSingleActivity.fulfilled, (state, action) => {
                state.activityIsLoading = false;
                state.agentActivity = action.payload;
            })
    },
});

export default agentActivitiesSlice.reducer;